import { createContext, useContext, useState, useCallback } from 'react'

const LoadingContext = createContext()

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)

  const showLoading = useCallback(() => setLoading(true), [])
  const hideLoading = useCallback(() => setLoading(false), [])

  return (
    <LoadingContext.Provider value={{ loading, showLoading, hideLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export const useLoading = () => {
  return useContext(LoadingContext)
}
